var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00122 14.0012C6.00122 13.7388 6.05292 13.4789 6.15337 13.2364C6.25381 12.9939 6.40104 12.7735 6.58664 12.5879C6.77224 12.4023 6.99258 12.2551 7.23508 12.1546C7.47758 12.0542 7.73749 12.0025 7.99997 12.0025C8.26245 12.0025 8.52236 12.0542 8.76486 12.1546C9.00736 12.2551 9.2277 12.4023 9.4133 12.5879C9.5989 12.7735 9.74613 12.9939 9.84658 13.2364C9.94702 13.4789 9.99872 13.7388 9.99872 14.0012C9.99872 14.5314 9.78814 15.0397 9.4133 15.4146C9.03846 15.7894 8.53007 16 7.99997 16C7.46987 16 6.96148 15.7894 6.58664 15.4146C6.2118 15.0397 6.00122 14.5314 6.00122 14.0012ZM6.1971 1.99875C6.17048 1.74659 6.19718 1.49165 6.27545 1.25047C6.35372 1.0093 6.48183 0.787271 6.65145 0.5988C6.82108 0.41033 7.02843 0.259625 7.26006 0.156467C7.49168 0.0533085 7.74241 0 7.99597 0C8.24954 0 8.50026 0.0533085 8.73189 0.156467C8.96352 0.259625 9.17087 0.41033 9.3405 0.5988C9.51012 0.787271 9.63822 1.0093 9.7165 1.25047C9.79477 1.49165 9.82147 1.74659 9.79485 1.99875L9.09529 9.00837C9.06686 9.28013 8.93879 9.53173 8.73578 9.71461C8.53277 9.8975 8.26921 9.9987 7.99597 9.9987C7.72273 9.9987 7.45918 9.8975 7.25617 9.71461C7.05316 9.53173 6.92508 9.28013 6.89666 9.00837L6.1971 1.99875Z",
    fill: "#ED4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiExclamation);
export default __webpack_public_path__ + "static/media/bi_exclamation.64c064a821d63242ce023a1614f71f98.svg";
export { ForwardRef as ReactComponent };